import { defineComponent as X, reactive as K, ref as f, onMounted as x, onBeforeUnmount as O, computed as b, nextTick as R, watch as P, createElementBlock as h, openBlock as v, createVNode as E, mergeProps as Y, createSlots as j, withCtx as d, createCommentVNode as V, renderSlot as w, normalizeStyle as $, createElementVNode as F, createTextVNode as G, toDisplayString as J } from "vue";
import { A as Q } from "./Select-Dbr2pXH_.js";
import { p as Z, s as ee, b as te } from "./baseMixins-HJffeBsS.js";
import { _ as oe } from "./Icon.ce.vue_vue_type_script_setup_true_lang-CdOC0ycX.js";
import { v as se } from "./v4-BMep7PEs.js";
import { _ as le } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const ae = { class: "advanced-select" }, re = { class: "arbo-select__item--prefix-icon flex" }, ne = {
  key: 0,
  class: "arbo-select__item--suffix-container"
}, ie = /* @__PURE__ */ X({
  __name: "StatusSelect",
  props: {
    ...te,
    ...ee,
    ...Z,
    labelKey: {
      type: String,
      default: "name"
    },
    prefixIconKey: {
      type: String,
      default: "color"
    },
    suffixIconKey: {
      type: String,
      default: "Xmark"
    },
    searchPlaceholder: {
      type: String,
      default: "Search..."
    },
    emptyText: {
      type: String,
      default: "No results, try again"
    },
    useAbsolutePosition: {
      type: Boolean,
      default: !1
    },
    showNavIcon: {
      type: Boolean,
      default: !0
    },
    wrapperListClass: {
      type: String,
      default: "status-select-wrapper"
    },
    isStatusDisplayEnabled: {
      type: Boolean,
      default: !0
    },
    customStatusSelect: {
      type: Boolean,
      default: !1
    },
    enableLimitTooltip: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue", "update:rawValue", "load-more", "input", "search", "shown", "hidden"],
  setup(S, { expose: L, emit: T }) {
    const o = S, a = K({
      selecting: null
    }), u = f(null), r = f(se());
    x(() => {
      o.modelValue && (a.selecting = o.modelValue), o.isStatusDisplayEnabled || window.addEventListener("resize", m);
    }), O(() => {
      window.removeEventListener("resize", m);
    });
    const C = b(() => o.options.find((l) => l.id == a.selecting)?.name), p = f(null), B = b(() => o.isStatusDisplayEnabled ? o.options.filter((e) => e.available == !0) : o.options), D = b(() => ({
      ...o,
      options: B.value,
      "wrapper-list-class": `status-select-wrapper status-select-${r.value}`,
      "data-instance-id": r.value
    })), i = T, k = (e) => {
      i("update:modelValue", e);
    }, _ = (e) => {
      e || (e = "#FFF");
      let l = "white";
      return (e.toUpperCase() === "#FFFFFF" || e.toUpperCase() === "#FFF" || e.toUpperCase() === "WHITE") && (l = "#A6A6A6"), {
        "--thumb-border-color": l,
        "--thumb-bg-color": e
      };
    }, m = async () => {
      await R();
      const e = document.querySelector(`.absolute-body.status-select-${r.value}`);
      e && (e.style.setProperty("visibility", "hidden", "important"), e.style.setProperty("top", "-9999px", "important"), e.style.setProperty("left", "-9999px", "important")), setTimeout(() => {
        const l = p.value?.$el;
        if (!l) return;
        const s = l.querySelector(".arbo-select__display"), t = document.querySelector(
          `.absolute-body.status-select-wrapper.status-select-${r.value}`
        ), n = document.querySelector(".arbo-select__list-wrapper");
        if (!s || !t || !n) return;
        u.value || (u.value = t.style.width || "auto");
        const c = s.getBoundingClientRect(), y = c.width;
        t.style.width = `${y}px`, n.style.width = `${y}px`, document.documentElement.style.setProperty(`--select-width-${r.value}`, `${y}px`);
        const W = window.scrollY || document.documentElement.scrollTop, z = window.scrollX || document.documentElement.scrollLeft, H = c.bottom + W, I = c.left + z;
        t.style.setProperty("position", "absolute", "important"), t.style.setProperty("top", `${H}px`, "important"), t.style.setProperty("left", `${I}px`, "important"), t.style.setProperty("transform", "none", "important"), t.style.setProperty("margin", "0", "important"), t.style.setProperty("margin-top", "14px", "important"), setTimeout(() => {
          t.style.setProperty("visibility", "visible", "important");
        }, 50);
      }, 20);
    }, A = () => {
      const e = document.querySelector(
        `.absolute-body.status-select-wrapper.status-select-${r.value}`
      ), l = document.querySelector(".arbo-select__list-wrapper");
      e && (e.style.width = u.value || "auto"), l && (l.style.width = u.value || "auto"), document.documentElement.style.setProperty(`--select-width-${r.value}`, u.value || "auto");
    }, M = async () => {
      i("load-more");
    }, N = (e) => {
      i("search", e);
    }, q = () => {
      o.isStatusDisplayEnabled || m(), i("shown");
    }, U = () => {
      g(), A(), i("hidden");
    }, g = () => {
      p.value && p.value.removeSearch();
    };
    return P(
      () => a.selecting,
      (e) => {
        i("input", e);
      }
    ), P(
      () => o.modelValue,
      (e) => {
        a.selecting = e;
      }
    ), x(() => {
      o.modelValue && (a.selecting = o.modelValue);
    }), L({
      clearSearch: g,
      show: () => {
        p.value.showList();
      }
    }), (e, l) => (v(), h("div", ae, [
      E(Q, Y(D.value, {
        ref_key: "arboStatusSelect",
        ref: p,
        modelValue: a.selecting,
        "onUpdate:modelValue": [
          l[0] || (l[0] = (s) => a.selecting = s),
          k
        ],
        class: "general-modal__payment-method__select",
        "is-enable-load-more": o.isEnableLoadMore,
        "is-using-search-server": !0,
        "is-enable-max-tooltip": !0,
        "enable-limit-tooltip": S.enableLimitTooltip,
        onLoadMore: M,
        onSearch: N,
        onShown: q,
        onHidden: U
      }), j({
        prefix_item: d(({ item: s, valueKey: t, labelKey: n, prefixIconKey: c }) => [
          w(e.$slots, "prefix_item", {
            item: s,
            valueKey: t,
            labelKey: n,
            prefixIconKey: c
          }, () => [
            F("div", re, [
              F("div", {
                class: "item-color",
                style: $(_(s[c]))
              }, null, 4)
            ])
          ], !0)
        ]),
        "prefix-item": d(({ selectingItem: s, displayValue: t, prefixIconKey: n }) => [
          w(e.$slots, "prefix-item", {
            selectingItem: s,
            displayValue: t,
            prefixIconKey: n
          }, () => [
            s ? (v(), h("div", {
              key: 0,
              class: "prefix-item--color item-color",
              style: $(_(s[n]))
            }, null, 4)) : V("", !0)
          ], !0)
        ]),
        suffix_item: d(({ item: s, prefixIconKey: t }) => [
          a.selecting !== null && a.selecting.includes(s.id) && o.customStatusSelect ? (v(), h("div", ne, [
            E(oe, {
              class: "arbo-select__item--icon-custom",
              name: t
            }, null, 8, ["name"])
          ])) : V("", !0)
        ]),
        _: 2
      }, [
        o.isStatusDisplayEnabled ? {
          name: "select-display",
          fn: d(({ toggleShowlist: s }) => [
            w(e.$slots, "activator", { toggleShowlist: s }, () => [
              G(J(C.value), 1)
            ], !0)
          ]),
          key: "0"
        } : void 0
      ]), 1040, ["modelValue", "is-enable-load-more", "enable-limit-tooltip"])
    ]));
  }
}), fe = /* @__PURE__ */ le(ie, [["__scopeId", "data-v-3f9cf084"]]);
export {
  fe as default
};
